import { LabelWithTextBox, LabelWithTextBoxProps } from 'components/input';
import React, { useCallback, useRef } from 'react';
import { PuckRenderer } from '../puck';
import { PuckDewarContainerView, PuckType } from '../puck/constants';
import { useAllPucks, useSelectedCrystalId } from 'redux/hooks/synchrotron';
import {
  getOccupiedPinsOfCurrentPuck,
  getCrystalById,
  getPuckById,
  getUpdatedCrystalsAfterCrystalContainerAssignments,
  getCrystalsByPuckId,
} from './utils';
import { useRMDispatch } from 'redux/hooks';
import { CrystalDataDTO } from '../constants';
import { setIsCrystalAssignmentsDirty } from 'redux/reducers/synchrotronTripReducer';
interface Props {
  setContentView: (view: PuckDewarContainerView) => void;
  disabled?: boolean;
  crystals: CrystalDataDTO[];
  setCrystals: React.Dispatch<React.SetStateAction<CrystalDataDTO[]>>;
}

const PuckInfo = (props: Props) => {
  const { setContentView, disabled, crystals, setCrystals } = props;
  const dispatch = useRMDispatch();
  const selectedCrystalId = useSelectedCrystalId();
  const pucks = useAllPucks();
  const selectedCrystal = getCrystalById(crystals, selectedCrystalId);
  const selectedPuck = getPuckById(
    pucks,
    selectedCrystal?.crystalContainerAssignments?.puckId,
  );
  const occupiedPins = getOccupiedPinsOfCurrentPuck(selectedPuck?.id, crystals);
  const canvasRef = useRef(null);

  const handleOnPuckClick = useCallback(() => {
    setContentView(PuckDewarContainerView.SelectPuckView);
  }, [setContentView]);

  const handleOnPinClick = (position) => {
    const updatedCrystals = getUpdatedCrystalsAfterCrystalContainerAssignments(
      crystals,
      selectedCrystalId,
      { puckPinPosition: position, isDirty: true },
    );
    setCrystals(updatedCrystals);
    dispatch(setIsCrystalAssignmentsDirty(true));
  };
  const crystalsOfSelectedPuck = getCrystalsByPuckId(crystals, selectedPuck?.id);

  const puckInfos: LabelWithTextBoxProps[] = [
    {
      label: 'Style',
      value: selectedPuck?.puckType?.name?.split(' ')[0],
      disabled,
    },
    { label: 'Barcode', value: selectedPuck?.barcode, disabled },
    { label: 'Pin Count', value: selectedPuck?.pinCount?.toString(), disabled },
    {
      label: 'Available',
      value: selectedPuck
        ? (selectedPuck?.pinCount - crystalsOfSelectedPuck.length)?.toString()
        : '',
      disabled,
    },
    {
      label: 'Position',
      value: selectedCrystal?.crystalContainerAssignments.puckPinPosition?.toString(),
      disabled,
    },
  ];

  const renderPuckInfoLabelWithValue = () =>
    puckInfos.map((item, index) => (
      <LabelWithTextBox {...item} key={index} labelWidth="50%" textBoxWidth="47%" />
    ));
  return (
    <div id="puckdewarcontainer-puckinfo-wrapper" className="flex flex-col w-full">
      <div
        id="puckdewarcontainer-puckinfo-title"
        className="text-base font-semibold text-gray-700"
      >
        Puck
      </div>
      <LabelWithTextBox
        label="Puck"
        value={selectedPuck?.name ?? 'Select Puck'}
        labelWidth={'20%'}
        textBoxWidth={'80%'}
        onClick={handleOnPuckClick}
        disabled={disabled}
      />
      <div id="puckdewarcontainer-puckinfo-details" className="flex flex-row w-full">
        <div id="puckdewarcontainer-puckinfo-label-with-value" className="w-2/5">
          {renderPuckInfoLabelWithValue()}
        </div>
        <div
          id="puckdewarcontainer-puckinfo-puck-renderer"
          ref={canvasRef}
          className="w-3/5 h-full"
          style={{ border: '1px solid' }}
        >
          <PuckRenderer
            parentRef={canvasRef}
            puckToShow={selectedPuck?.puckType?.name as PuckType}
            occupiedPins={occupiedPins}
            handleOnPinSelect={handleOnPinClick}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default PuckInfo;
